<div class="modal-header">
    <h4 *ngIf="students && students?.length>0" class="modal-title">Students<h6 class="mr-2" *ngIf="students[0]?.student_info && students?.length>0">({{students?.length}})</h6> and their topics</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="students && students?.length>0  && students[0]?.student_info; else noStudents">
    <ul class="nav nav-tabs">
      <li *ngFor="let student of students; let i = index" class="nav-item">
        <a class="nav-link" [ngClass]="{'active': i === selectedIndex}" (click)="selectStudent(i)">
          {{ student?.student_info?.name }}
        </a>
      </li>
    </ul>
    <div *ngIf="students && students.length">
      <h5 class="mt-3 modal-title">Topics<h6 class="mr-2" *ngIf="students[selectedIndex]?.topic_info?.length">({{students[selectedIndex]?.topic_info?.length}})</h6> for {{ students[selectedIndex]?.student_info?.name }}</h5>
      <ul *ngIf="students[selectedIndex]?.topic_info?.length; else noTopics" class="list-group mt-2">
        <li *ngFor="let topic of students[selectedIndex]?.topic_info" class="list-group-item">
          {{ topic?.name }}
        </li>
      </ul>
      <ng-template #noTopics>
        <p>No topics available for this student.</p>
      </ng-template>
    </div>
  </div>
  <ng-template #noStudents>
    <p class="text-center">No students available.</p>
  </ng-template>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
  </div>
  